import { createEvent, createStore } from 'effector'
import { createGate } from 'effector-react'

import {
  type CollectionsListPageTabsKeys,
  DEFAULT_COLLECTIONS_LIST_PAGE_TAB,
} from '../lib/tabs'

// Gate
export const CollectionsListPageGate = createGate()

// Tab
export const collectionsListPageTabChanged =
  createEvent<CollectionsListPageTabsKeys>()
export const $collectionsListPageTab = createStore<CollectionsListPageTabsKeys>(
  DEFAULT_COLLECTIONS_LIST_PAGE_TAB,
).on(collectionsListPageTabChanged, (_, payload) => payload)
